import FlashcardsCardGrid from "@/components/flashcards/FlashcardsCardGrid";
import { useFlashcardsFlipCompletion } from "@/hooks/flashcards/useFlashcardsFlipCompletion";
import type { TextFlashcardData } from "@/types/storyboard";

interface FlashcardsInlineGridProps {
  cards: TextFlashcardData[];
  contentElementId: string;
  className?: string;
}

/**
 * Three-column wrap/center flashcard grid — used to show every Lernkarte in a
 * lesson as an independently flippable card and complete the CE on flip-all.
 */
const FlashcardsInlineGrid = ({
  cards,
  contentElementId,
  className,
}: FlashcardsInlineGridProps) => {
  const { flippedByIndex, toggleCardFlip } = useFlashcardsFlipCompletion(
    contentElementId,
    cards.length
  );

  return (
    <FlashcardsCardGrid
      cards={cards}
      flippedByIndex={flippedByIndex}
      onFlip={toggleCardFlip}
      className={className}
    />
  );
};

export default FlashcardsInlineGrid;
